import type {WorkstreamMetric} from 'client';

export type WorkstreamMetricPickerOption = {
  kind: 'workstream';
  optionId: string;
  title: string;
  subtitle?: string;
  metric: WorkstreamMetric;
};

export const buildWorkstreamMetricPickerOption = (
  metric: WorkstreamMetric
): WorkstreamMetricPickerOption => ({
  kind: 'workstream',
  optionId: `workstream:${metric.id}`,
  title: metric.title,
  subtitle: metric.owner?.name ?? undefined,
  metric,
});
